// extracted by mini-css-extract-plugin
var _1 = "Skeleton_animation_pulse__Na3ND";
var _2 = "Skeleton_animation_wave__BLpYb";
var _3 = "Skeleton_circular__78CVe";
var _4 = "Skeleton_pulse__5QAlL";
var _5 = "Skeleton_rectangular__Fm+hr";
var _6 = "Skeleton_skeleton__MgvsQ";
var _7 = "Skeleton_text__TAYVw";
var _8 = "Skeleton_wave__Oap6n";
export { _1 as "animation_pulse", _2 as "animation_wave", _3 as "circular", _4 as "pulse", _5 as "rectangular", _6 as "skeleton", _7 as "text", _8 as "wave" }
